import { render, staticRenderFns } from "./ReclamationDialog.vue?vue&type=template&id=844a3c14"
import script from "./ReclamationDialog.vue?vue&type=script&lang=js"
export * from "./ReclamationDialog.vue?vue&type=script&lang=js"
import style0 from "./ReclamationDialog.vue?vue&type=style&index=0&id=844a3c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReclamationDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports